document.addEventListener('DOMContentLoaded', function () {
  const stickyGallery = document.querySelector('.product-gallery--sticky');
  const header = document.querySelector('[data-site-header]') || document.getElementById('custom-header');

  if (stickyGallery && header) {
    var lastHeight = 0;
    var updateGalleryTop = function() {
      var h = header.offsetHeight;
      if (h !== lastHeight) {
        lastHeight = h;
        stickyGallery.style.setProperty('--gallery-sticky-top', h + 'px');
      }
    };
    updateGalleryTop();
    window.addEventListener('resize', updateGalleryTop);
    window.addEventListener('scroll', updateGalleryTop, { passive: true });
  }
});